import utils from 'utils'

class synchronousModal {
    constructor($scope, httpRequest, globalFn, logger, $uibModalInstance, $location, $state, $stateParams, $uibModal) {
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            // 返回数据
            $uibModalInstance.close()
        }
    }
}

synchronousModal.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$uibModalInstance', '$location', '$state', '$stateParams', '$uibModal']
export default synchronousModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/selectTicket/synchronousModal.js